import React from "react";
import MetricInfoTooltip, {
  MetricTooltipKey,
} from "components/MetricInfoTooltip";
import type { SellerPublicCard } from "reducers/companyProfileApi";

interface ProductSellerMetricPanelProps {
  metrics: SellerPublicCard["metrics"];
}

const normalizeMetric = (value: number) =>
  Math.round(Math.min(100, Math.max(0, value)));

const ProductSellerMetricPanel = ({
  metrics,
}: ProductSellerMetricPanelProps) => {
  const items: {
    key: MetricTooltipKey;
    label: string;
    value: number | null;
  }[] = [
    { key: "value", label: "価値", value: metrics.value },
    {
      key: "reliability",
      label: "信頼性",
      value: metrics.reliability,
    },
    {
      key: "circulation",
      label: "環境貢献",
      value: metrics.circulation,
    },
  ];

  return (
    <div className="flex min-h-[314px] flex-col rounded-md border border-[#002959] bg-[linear-gradient(154.13deg,#1B4B86_0%,#002959_99.28%)] px-[15px] py-5 text-white shadow-md md:min-h-[514px] md:px-[30px] md:pb-[30px] md:pt-[20px]">
      <div className="flex flex-1 flex-col justify-center">
        <h3 className="mb-[15px] text-center text-lg font-bold md:mb-5 md:text-[20px]">
          短縮ゲーム指数
        </h3>
        <div className="flex flex-col gap-5 md:gap-[30px]">
          {items.map((item) => {
            const hasValue = item.value !== null;
            const value = item.value !== null ? normalizeMetric(item.value) : 0;

            return (
              <div key={item.key}>
                <div className="flex h-[26px] items-end justify-between gap-[15px] md:h-[29px]">
                  <span className="flex items-center gap-[5px] text-xs font-bold md:text-[14px]">
                    <span>{item.label}</span>
                    <MetricInfoTooltip
                      metricKey={item.key}
                      label={item.label}
                      className="text-white/85"
                    />
                  </span>
                  <span
                    className={`font-['Audiowide'] text-2xl leading-[110%] md:text-[26px] ${
                      hasValue ? "text-[#d4f754]" : "text-[#aab5c2]"
                    }`}
                  >
                    {hasValue ? value : "--"}
                    <span className="ml-0.5 font-sans text-[11px] font-bold text-white md:text-xs">
                      %
                    </span>
                  </span>
                </div>
                <div className="mt-[5px] h-3 overflow-hidden rounded-md bg-[#002959] md:h-4 md:rounded-lg">
                  {hasValue && (
                    <div
                      className="h-full bg-[linear-gradient(90deg,#d4f754_0%,#2cdcec_100%)]"
                      style={{ width: `${value}%` }}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <p className="mt-[25px] text-left text-[11px] leading-[160%] text-[#eef5fa]/50 md:mt-[30px] md:text-right md:text-xs">
          ※各指数は直近360日間の実績に基づき算出されています。
        </p>
      </div>
    </div>
  );
};

export default ProductSellerMetricPanel;
